// Regex expression to validate an UUID pattern
// Assumes the UUID is in dashes format
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function compareUUIDs(a: string, b: string): boolean {
  // Sometimes UUIDs have '-' characters in them, sometimes they don't 🙄
  return a.toLowerCase().replace(/-/g, "") === b.toLowerCase().replace(/-/g, "");
}
